import { render, staticRenderFns } from "./AccountView.vue?vue&type=template&id=18dd36e4"
import script from "./AccountView.vue?vue&type=script&lang=js"
export * from "./AccountView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports